<template>
  <!-- 通过key实现tab切换实现组件更新，否则就要实现各种tab下的数据切换 -->
  <receive-bill-item
    :key="type"
    :type="type"
    @tab="onTab"
  ></receive-bill-item>
</template>

<script>
/** 应收订单 */

import receiveBillItem from './children/receive_bill_item';

export default {
  name: 'receiveBill',
  mixins: [],
  components: {
    receiveBillItem
  },
  data() {
    return {
      // 3- 全部 1 - 待收款，2 - 已收款
      type: 3
    };
  },
  mounted: function () {

  },
  methods: {
    onTab(value) {
      this.type = value;
    }
  },
};
</script>

<style lang="scss">
</style>
